import type {
  DraggableAttributes,
  DraggableSyntheticListeners,
} from '@dnd-kit/core';

import { createContext, useContext } from 'react';

export type SortableItemContextValue = {
  attributes: DraggableAttributes;
  /** Whether this item is the one being dragged. */
  isDragging: boolean;
  listeners: DraggableSyntheticListeners;
  setActivatorNodeRef: (element: HTMLElement | null) => void;
};

export const SortableItemContext = createContext<
  SortableItemContextValue | undefined
>(undefined);

/**
 * Reads the enclosing `SortableItem`'s activator wiring, if any. Returns
 * `undefined` outside a `SortableItem` — callers (e.g. `SortableHandle`)
 * fall back to whatever activator props they were given directly, so they
 * still work when wired to a different drag-and-drop setup by hand.
 */
export function useSortableItemContext() {
  return useContext(SortableItemContext);
}
